import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Card, Button, Table, notification } from "antd";
import { OrgUpload } from "./components/OrgUpload";
import { useMutation, useLazyQuery } from "@apollo/react-hooks";
import { OrgGql, FindStudents } from "../../graphql/organization";

export const OrgImport = () => {
  let { id } = useParams<any>();
  const [students, setStudents] = useState([]);
  const [importOrgData] = useMutation(OrgGql.importOrgData);
  const history = useHistory();
  const [findStudents] = useLazyQuery<any>(FindStudents, {
    variables: { orgId: id },
  });

  const save = () => {
    const input = students.map((x: any) => {
      const { __typename, ...other } = x;
      return other;
    });

    importOrgData({ variables: { input } })
      .then((res) => {
        console.log("uploaded", res);
        notification.success({ message: `Import data successed!` });
        setStudents([]);
        history.push(`/orgs/${id}/students`);
      })
      .catch((err) => {});
  };

  const columns = [
    {
      title: "Student First Name",
      dataIndex: "childFirstName",
      key: "childFirstName",
    },
    {
      title: "Student Last Name",
      dataIndex: "childLastName",
      key: "childLastName",
    },
    {
      title: "Student Grade",
      dataIndex: "childGrade",
      key: "childGrade",
    },
    {
      title: "Student Email",
      dataIndex: "childEmail",
      key: "childEmail",
    },
    {
      title: "Parent First Name",
      dataIndex: "parentFirstName",
      key: "parentFirstName",
    },
    {
      title: "Parent Last Name",
      dataIndex: "parentLastName",
      key: "parentLastName",
    },
    {
      title: "Parent Email",
      dataIndex: "parentEmail",
      key: "parentEmail",
    },
    {
      title: "Validation",
      dataIndex: "valid",
      key: "valid",
      render: (_, r) => <div></div>,
    },
  ];

  return (
    <>
      <Card title="Importing Data" size="small" bodyStyle={{ padding: 0 }}>
        <Table rowKey="id" size="small" columns={columns} dataSource={students} />

        <div style={{ textAlign: "center", marginTop: 15 }}>
          {students.length > 0 && (
            <Button type="primary" size="large" onClick={save}>
              Import Data
            </Button>
          )}
        </div>
      </Card>

      <OrgUpload orgId={id} onLoaded={(data) => setStudents(data.map((x, i) => ({ id: i + "", ...x })))} />
    </>
  );
};
